// extracted by mini-css-extract-plugin
module.exports = {"block":"styles_block__1YCwA","boldCountry":"styles_boldCountry__PVcOk","selectCountry":"styles_selectCountry__3VQyc"};